export const GET_PORTAL_LINKS = "GET_PORTAL_LINKS";
export const GET_PORTAL_LINKS_SUCCESS = "GET_PORTAL_LINKS_SUCCESS";
export const GET_PORTAL_LINKS_FAIL = "GET_PORTAL_LINKS_FAIL";

export const ADD_PORTAL_LINK = "ADD_PORTAL_LINK";
export const ADD_PORTAL_LINK_SUCCESS = "ADD_PORTAL_LINK_SUCCESS";
export const ADD_PORTAL_LINK_FAIL = "ADD_PORTAL_LINK_FAIL";

export const UPDATE_PORTAL_LINK = "UPDATE_PORTAL_LINK";
export const UPDATE_PORTAL_LINK_SUCCESS = "UPDATE_PORTAL_LINK_SUCCESS";
export const UPDATE_PORTAL_LINK_FAIL = "UPDATE_PORTAL_LINK_FAIL";

export const DELETE_PORTAL_LINK = "DELETE_PORTAL_LINK";
export const DELETE_PORTAL_LINK_SUCCESS = "DELETE_PORTAL_LINK_SUCCESS";
export const DELETE_PORTAL_LINK_FAIL = "DELETE_PORTAL_LINK_FAIL";

export const SET_PORTAL_LINKS_FIELD_ERRORS = "SET_PORTAL_LINKS_FIELD_ERRORS";
